import React from 'react';
import { motion } from 'framer-motion';
import { Building2, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
export function ReferencesSection() {
  const clients = ['Croonwolter&dros', 'Heijmans Utiliteit', 'Stork Nederland', 'Tata Steel', 'Van Gelder', 'Unica', 'TES Industrial Systems'];
  return <section className="py-24 bg-white" data-id="element-212">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213">
        <div className="text-center mb-16" data-id="element-214">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-215">
            Vertrouwd door toonaangevende opdrachtgevers
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-600" data-id="element-216">
            Wij werkten onder andere voor:
          </motion.p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mb-16" data-id="element-217">
          {clients.map((client, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-gray-50 h-32 rounded-lg flex flex-col items-center justify-center p-6 text-center hover:bg-white hover:shadow-lg transition-all duration-300 border border-gray-100 group" data-id="element-218">
              <Building2 className="w-8 h-8 text-gray-300 mb-3 group-hover:text-[#2E78B6] transition-colors" data-id="element-219" />
              <span className="font-bold text-gray-700 group-hover:text-[#2E78B6] transition-colors" data-id="element-220">
                {client}
              </span>
            </motion.div>)}

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="bg-[#2E78B6] h-32 rounded-lg flex flex-col items-center justify-center p-6 text-center text-white" data-id="element-221">
            <span className="font-bold text-lg" data-id="element-222">En vele anderen...</span>
          </motion.div>
        </div>

        <div className="text-center" data-id="element-223">
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-224">
            Van datacenters tot energievoorzieningen en industriële
            installaties. Wij hebben de ervaring die uw project nodig heeft.
          </p>
          <Button className="bg-[#F57C00] hover:bg-[#E56A00] text-white" data-id="element-225">
            Vraag onze referentielijst aan
          </Button>
        </div>
      </div>
    </section>;
}